module.exports = __webpack_public_path__ + "img/frasagal03.a46dc76c.png";